<template>
    <form class="lading-page">
        <div class="lading-page-body">
            <p class="summary-text">
                {{ landingPageMessage }}
            </p>
            <table class="table-lp">
                <tr>
                    <td class="left-column">
                        <ds-multiselect
                            id="landing-page-multiselect"
                            v-model="landingPageValue"
                            searchable
                            bind-value-only
                            :placeholder="MESSAGE_CONSTANTS.selectLandingPage_placeholder"
                            :loading="loadingLandingPage"
                            :options="landingPagesSites"
                            @input="clearFormValues"
                        />
                    </td>
                    <td class="right-column">
                        <ds-outline-button
                            class="edition"
                            :disabled="shouldEnableEdit"
                            @click="editLandingPage"
                        >
                            {{ MESSAGE_CONSTANTS.edit }}
                        </ds-outline-button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="single-column">
                        <ds-multiselect
                            id="form-multiselect"
                            v-model="formValues"
                            multiple
                            bind-value-only
                            searchable
                            :placeholder="MESSAGE_CONSTANTS.selectForm_placeholder"
                            :loading="loadingLandingPage || loadingPages"
                            :options="landingPages"
                            @input="siteValuesInput"
                        />
                    </td>
                </tr>
            </table>
            <table v-if="isFs51395Enabled" class="table-lp">
                <tr class="flex-config">
                    <td>
                        <ds-text-button
                            id="create-landing-page-button"
                            @click="openConvrrtEditor"
                        >
                            <template #default>
                                {{ MESSAGE_CONSTANTS.createLandingPage }}
                            </template>
                            <template #trailing>
                                <ds-icon name="external-link" />
                            </template>
                        </ds-text-button>
                    </td>
                    <td v-if="landingPagesSites.length > 0">
                        <ds-text-button
                            id="manage-landing-pages-button"
                            @click="openConvrrtEditor"
                        >
                            <template #default>
                                {{ MESSAGE_CONSTANTS.manageLandingPage }}
                            </template>
                            <template #trailing>
                                <ds-icon name="external-link" />
                            </template>
                        </ds-text-button>
                    </td>
                </tr>
            </table>
        </div>
        <ds-icon-button
            :aria-label="MESSAGE_CONSTANTS.close"
            class="close-modal"
            @click="closeModal"
        >
            <ds-icon name="x" />
        </ds-icon-button>
        <ds-filled-button
            class="save-button"
            :disabled="shouldEnableSave"
            @click="saveCell"
        >
            {{ MESSAGE_CONSTANTS.save }}
        </ds-filled-button>
    </form>
</template>
<script>

//

import { dataService } from '../shared/data.service';

export default {
    data() {
        return {
            landingPageValue: '',
            formValues: [],
            formValuesCopy: [],
            formValuesToDelete: [],
            newFormValues: [],
            graph: {},
            cell: {},
            cellValue: {},
            saveCellOptions: {},
            landingPagesSites: [],
            landingPages: [],
            landingPageFormOptions: [],
            saveEnabled: false,
            loadingLandingPage: false,
            loadingPages: false,
            landingPageMessage: {},
            MESSAGE_CONSTANTS: {
                message: '',
                selectLandingPage_placeholder: '',
                selectForm_placeholder: '',
                createLandingPage: '',
                manageLandingPage: '',
                save: '',
                close: '',
                edit: '',
            },
            isFs51395Enabled: true,
        };
    },

    async created() {
        await this.loadLandingPages();
    },

    mounted () {
        this.cell = Infusion.Funnel.Goal.ConvrrtLandingPage.getCell();
        this.graph = Infusion.Funnel.Goal.ConvrrtLandingPage.getGraph();
        this.isFs51395Enabled = Infusion.Funnel.Flags.isConvrrtSideNavEnabled();
        this.cellValue = Infusion.Funnel.Cell.getCellValue(this.cell);
        this.landingPageMessage = window.keapI18nMap['campaign.landing.page.message'];

        this.landingPageValue = this.cellValue ? this.cellValue.convrrtLandingPageId : '';
        this.formValues = this.cellValue ? this.cellValue.leadBucketIds : [];
        this.formValuesCopy = this.formValues;

        this.MESSAGE_CONSTANTS.message = window.keapI18nMap['campaign.landing.page.message'];
        this.MESSAGE_CONSTANTS.selectLandingPage_placeholder = window.keapI18nMap['campaign.landing.page.selectLandingPage.placeholder'];
        this.MESSAGE_CONSTANTS.selectForm_placeholder = window.keapI18nMap['campaign.landing.page.selectForm.placeholder'];
        this.MESSAGE_CONSTANTS.createLandingPage = window.keapI18nMap['campaign.landing.page.createLandingPage'];
        this.MESSAGE_CONSTANTS.manageLandingPage = window.keapI18nMap['campaign.landing.page.manageLandingPage'];
        this.MESSAGE_CONSTANTS.save = window.keapI18nMap['campaign.landing.page.save'];
        this.MESSAGE_CONSTANTS.edit = window.keapI18nMap['campaign.landing.page.edit'];
        this.MESSAGE_CONSTANTS.close = window.keapI18nMap['campaign.landing.page.configure.close'];
    },

    computed: {
        shouldEnableSave: {
            cache: false,
            get() {
                const saveEnabled = this.landingPageValue !== '' && this.formValues !== null && this.formValues.length > 0 && this.saveEnabled === true;

                return !saveEnabled;
            },
        },
        shouldEnableEdit: {
            cache: false,
            get() {
                const editEnabled = this.landingPageValue && this.landingPageValue !== '';

                return !editEnabled;
            },
        },
    },

    methods: {
        closeModal() {
            document.querySelector('span.container-close').click();
        },

        async saveCell() {
            let leadBucketToRemove = [];
            let leadBucketFunnelMapIdsByPageId = [];
            let leadBucketIdsToRemove = [];
            let formsToAdd = [];
            const isEditing = this.cellValue.convrrtLandingPageId !== '';

            // The following logic is to handle the editing of the goal
            if (isEditing) {
                leadBucketToRemove = this.getLeadBucketToRemove();
                formsToAdd = this.getFormsToAdd();

                // if leadBucketToRemove.length > 0 means that there are leadBucketFunnelMapIds to remove
                if (leadBucketToRemove.length > 0) {
                    leadBucketFunnelMapIdsByPageId = await dataService.getLeadBucketIdsByPageIds(leadBucketToRemove);

                    if (leadBucketFunnelMapIdsByPageId.length > 0) {
                        // Retrieves the leadBucketIds for this specific goal that need to be removed
                        leadBucketIdsToRemove = this.getLeadBucketFunnelMapIdsToRemove(leadBucketFunnelMapIdsByPageId);

                        await dataService.deleteLeadBucketIdsByIds(leadBucketIdsToRemove);
                    }
                }
            }

            Infusion.Funnel.Goal.ConvrrtLandingPage.saveModalConfig(this.landingPageValue, this.formValues, this.graph, this.cell, leadBucketIdsToRemove, formsToAdd, isEditing);
            this.closeModal();
        },

        getLeadBucketToRemove() {
            const bucketsToDelete = [];

            for (let i = 0; i < this.formValuesCopy.length; i++) {
                if (!this.newFormValues.includes(this.formValuesCopy[i])) {
                    bucketsToDelete.push(this.formValuesCopy[i]);
                }
            }

            return bucketsToDelete;
        },

        getFormsToAdd() {
            const getFormsToAdd = [];

            for (let i = 0; i < this.newFormValues.length; i++) {
                if (!this.formValuesCopy.includes(this.newFormValues[i])) {
                    getFormsToAdd.push(this.newFormValues[i]);
                }
            }

            return getFormsToAdd;
        },

        getLeadBucketFunnelMapIdsToRemove(leadBucketFunnelMapIdsByPageId) {
            const idsToRemove = [];

            for (const value of leadBucketFunnelMapIdsByPageId) {
                const stringValue = value.toString();

                if (Array.isArray(this.cellValue.leadBucketFunnelMapId)) {
                    if (this.cellValue.leadBucketFunnelMapId.includes(stringValue) || this.cellValue.leadBucketFunnelMapId.includes(value)) {
                        idsToRemove.push(value);
                    }
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (this.cellValue.leadBucketFunnelMapId === stringValue || this.cellValue.leadBucketFunnelMapId === value) {
                        idsToRemove.push(value);
                    }
                    // eslint-enable-next-line no-lonely-if
                }
            }

            return idsToRemove;
        },

        openConvrrtEditor() {
            Infusion.Funnel.Goal.ConvrrtLandingPage.goToConvrrtEditor(this.graph, this.cell, false, '');
            this.closeModal();
        },

        editLandingPage() {
            Infusion.Funnel.Goal.ConvrrtLandingPage.goToConvrrtEditor(this.graph, this.cell, true, this.landingPageValue);
            this.closeModal();
        },

        async clearFormValues() {
            try {
                this.loadingPages = true;
                this.saveEnabled = false;

                if (this.landingPageValue) {
                    this.landingPages = await dataService.getConvrrtLandingPages(this.landingPageValue);
                }
            } finally {
                this.loadingPages = false;
            }
        },

        async loadLandingPages() {
            try {
                this.loadingLandingPage = true;
                this.landingPagesSites = await dataService.getConvrrtLandingPagesSites();

                if (this.landingPageValue) {
                    this.loadingPages = true;
                    this.landingPages = await dataService.getConvrrtLandingPages(this.landingPageValue);

                    this.formValues = this.cellValue ? this.cellValue.leadBucketIds : [];
                    this.formValuesCopy = this.formValues;
                }
            } finally {
                this.loadingLandingPage = false;

                if (this.landingPageValue) {
                    this.loadingPages = false;
                }
            }
        },

        siteValuesInput(value) {
            this.saveEnabled = true;

            this.newFormValues = [];
            this.newFormValues = value;
        },
    },
};

</script>

<style lang="scss">
.lading-page-body .ds-card {
    width: 100%;
    background-color: #f0f0f0;
}
.table-lp {
    border: 0rem;
    cellpadding: 0rem;
    cellspacing: 0rem;
    .flex-config {
        align-items: center;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        & > td {
            padding: 0.1rem;
            min-width: 25%;
        }
    }
}
.table-lp > tr {
    padding: 0.1rem !important;
    border-bottom: none !important;
}
.table-lp .left-column {
    padding: 0.1rem !important;
    width: 75%;
}
.table-lp .right-column {
    padding: 0.1rem !important;
    text-align: right;
    width: 25%;
}
.table-lp .single-column {
    padding: 0.1rem !important;
}
svg.icon {
    width: 48px;
    padding-left: 0px;
}
.modal-footer {
    visibility: hidden;
    display: none;
}
div#lightbox {
    display: grid;
    grid-template-areas: 'containerclose headertext savebutton' 'lightboxcontent lightboxcontent lightboxcontent';
    grid-template-columns: 6% 80% 14%;
    background-color: #fff;
}
div#lightbox > div#lightbox-content {
    grid-area: lightboxcontent;
    border-top: 1px solid #DDDDDD;
}
div#lightbox > div.hd {
    grid-area: headertext;
    background-color: #fff;
    border-bottom: none;
    height: 45px;
    font-weight: bold !important;
    margin-left: 10px;
    color: rgba(0, 0, 0, 0.825);
}
form > .closemodal {
    grid-area: containerclose;
    background-color: #fff;
    padding: 0;
    margin: 0;
    left: 20px;
    width: auto;
    height: auto;
    position: absolute;
    top: 12px;
    left: 12px;
}
form > .savebutton {
    grid-area: savebutton;
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
    color: var(--text-color, white);
}
span.container-close {
    visibility: hidden;
}
p.summary-text {
    margin-top: 15px;
    margin-bottom: 20px;
}
.dropdown-menu.open {
    border: none;
    padding: 0px;
}
div#form-multiselect > div.dropdown > div.dropdown-reference> div.input-container > div.multiselect-tags > span.input-span > label.pill-label{
    display: flex !important;
}
</style>

<style lang="scss" scoped>
.lading-page {
    width:      100%;
    height:     fit-content;
    margin:     0;
    padding:    0;
}
.lading-page-header {
    display:                grid;
    width:                  100%;
    padding:                12px;
    grid-template-columns:  24px 485px 65px;
    border-bottom:          1px solid rgba(0,0,0,.12);
}
.lading-page-header > h4 {
    margin: 12px 0 0 16px;
}
.lading-page-body {
    width:  100%;
    padding:    4px 24px 16px 24px;
}
.summary-header {
    margin-top:     8px;
    color:          #69697b;
    font-size:      12px;
    font-weight:    400;
}
.summary-body {
    margin-bottom: 24px;
    font-size: 16px;
}
form > .close-modal {
    grid-area: containerclose;
    position: absolute;
    top: 8px;
    left: 8px;
}
form > .save-button {
    grid-area: savebutton;
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
}
form > .button > .edition {
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
    button-text-color: #0042DB !important;
    button-background-color: #ffffff !important;
}
#form-multiselect {
    margin-bottom: 20px;
}
</style>
